<template>
  <div class="tradeOrderCreate">
    <!-- 头部导航 -->
    <div class="header" v-if="TODId">
      <div class="header-left">
        <van-button type="info" size="small" @click="dialogDraftListShow">
          {{ $t.tradeOrder.viewDraft }}
        </van-button>
      </div>
      <div class="header-center" v-if="DraftName">
        {{ DraftName }}
      </div>
      <div class="header-right">
        <van-button type="danger" size="small" @click="deleteTradeOrderDraft">
          {{ $t.tradeOrder.deleteDraft }}
        </van-button>
      </div>
    </div>

    <!-- 主要内容区域 - 使用折叠面板 -->
    <van-collapse v-model="activeCollapse" class="collapse-container">
      <!-- 采购信息面板 -->
      <van-collapse-item :title="$t.tradeOrder.collapse1" name="purchase">
        <van-form
          ref="form"
          label-width="120px"
          :show-error="false"
          :scroll-to-error="false"
          @failed="onFailed"
          @submit="procurementProductSubmit"
        >
          <!-- 搜索筛选 -->
          <div class="search-section">
            <van-search
              v-model="searchForm.ProductName"
              :placeholder="$t.tradeOrder.productNameSn"
              shape="round"
              @search="onSearch"
            />
            <div class="search-tags">
              <van-field
                v-model="searchForm.Brand"
                :placeholder="$t.tradeOrder.brand"
                class="tag-input"
              />
              <van-field
                v-model="searchForm.Model"
                :placeholder="$t.tradeOrder.model"
                class="tag-input"
              />
              <van-field
                v-model="searchForm.Specifications"
                :placeholder="$t.tradeOrder.specifications"
                class="tag-input"
              />
            </div>
            <div style="padding: 16px">
              <van-button
                round
                block
                type="primary"
                native-type="button"
                @click="onSearch"
              >
                {{ $t.tradeOrder.searchProduct }}
              </van-button>
            </div>
          </div>

          <!-- 产品选择 -->
          <div class="product-select">
            <van-cell-group>
              <van-field
                v-model="form.selectedProduct.text"
                :label="$t.tradeOrder.productName"
                :name="$t.tradeOrder.productName"
                readonly
                :placeholder="$t.meta.select"
                @click="onShowEmit('showTradeOrderCreateProduct')"
                required
                :rules="formRule"
              />
            </van-cell-group>

            <!-- 产品图片预览 -->
            <div v-if="form.selectedProduct.value" class="product-preview">
              <van-image
                :src="imgUrlFilter(form.selectedProduct.value.ProductImages)"
                @click="
                  imagePreview(imgUrlFilter(form.selectedProduct.value.ProductImages))
                "
                width="80"
                height="80"
                fit="cover"
              >
                <template v-slot:error>
                  <span>{{ $t.tradeOrder.noImage }}</span>
                </template>
              </van-image>
            </div>

            <!-- 产品详情信息 -->
            <van-cell-group v-if="form.selectedProduct.value">
              <van-cell
                :title="$t.tradeOrder.customsDeclarationName"
                :value="form.selectedProduct.value.CustomsDeclarationName"
              />
              <van-cell
                :title="$t.tradeOrder.productNameEn"
                :value="form.selectedProduct.value.ProductNameEn"
              />
              <van-cell
                :title="$t.tradeOrder.domesticPlaceOrigin"
                :value="form.selectedProduct.value.DomesticPlaceOrigin"
              />
              <van-cell
                :title="$t.tradeOrder.brand"
                :value="form.selectedProduct.value.Brand"
              />
              <van-cell
                :title="$t.tradeOrder.model"
                :value="form.selectedProduct.value.Model"
              />
              <van-cell
                :title="$t.tradeOrder.specifications"
                :value="form.selectedProduct.value.Specifications"
              />
              <van-cell
                :title="$t.tradeOrder.unitName"
                :value="form.selectedProduct.value.UnitName"
              />
              <van-cell
                :title="$t.tradeOrder.hsCode"
                :value="form.selectedProduct.value.HSCode"
              />
            </van-cell-group>

            <!-- 供应商和报价 -->
            <van-cell-group>
              <van-field
                v-model="form.selectedCompany.text"
                :label="$t.tradeOrder.supplier"
                :name="$t.tradeOrder.supplier"
                readonly
                required
                :rules="formRule"
                :placeholder="$t.meta.select"
                :disabled="!form.selectedProduct.value"
                @click="pickerShow('showCompanyPicker')"
              />
              <van-field
                v-model="form.selectedQuotation.text"
                :label="$t.tradeOrder.quotation"
                :name="$t.tradeOrder.quotation"
                readonly
                required
                :rules="formRule"
                :placeholder="$t.meta.select"
                :disabled="!form.selectedCompany.value"
                @click="pickerShow('showQuotationPicker')"
              />
              <van-field
                v-model="form.selectedEntity.text"
                :label="$t.tradeOrder.entity"
                :name="$t.tradeOrder.entity"
                readonly
                required
                :rules="formRule"
                :placeholder="$t.meta.input"
                @click="onShowEmit('showTradeOrderCreateEntity1')"
              />
              <van-field
                v-model="form.selectedQty"
                :label="$t.tradeOrder.quantity"
                :name="$t.tradeOrder.quantity"
                type="number"
                :placeholder="$t.meta.input"
                required
                :rules="formRule"
              />
            </van-cell-group>

            <!-- 报价详情 -->
            <van-cell-group v-if="form.selectedQuotation.value">
              <van-cell
                :title="$t.tradeOrder.preTaxPurchasePrice"
                :value="form.selectedQuotation.value.PreTaxPurchasePrice"
              />
              <van-cell
                :title="$t.tradeOrder.invoicingTaxRate"
                :value="form.selectedQuotation.value.InvoicingTaxRate"
              />
              <van-cell
                :title="$t.tradeOrder.afterTaxPurchasePrice"
                :value="form.selectedQuotation.value.AfterTaxPurchasePrice"
              />
              <van-cell
                :title="$t.tradeOrder.minimumOrderQuantity"
                :value="form.selectedQuotation.value.MinimumOrderQuantity"
              />
              <van-cell
                :title="$t.tradeOrder.procurementConsiderations"
                :value="form.selectedQuotation.value.ProcurementConsiderations"
              />
            </van-cell-group>
          </div>

          <!-- 采购清单 -->
          <div class="product-list">
            <div class="list-title">{{ $t.tradeOrder.subTitle1 }}</div>
            <div v-if="procurementProductList.length > 0">
              <van-card
                v-for="(item, index) in procurementProductList"
                :key="index"
                :title="item.ProductName"
                :thumb="imgUrlFilter(item.ProductImage)"
                :price="item.PurchaseUnitPrice.toFixed(4)"
                :num="item.PurchaseQuantity + item.UnitName"
              >
                <template #tags>
                  <div style="font-size: 10px">
                    {{ $t.tradeOrder.supplier }}: {{ item.CustomerName }}
                  </div>
                  <div style="font-size: 10px">
                    {{ $t.tradeOrder.entity }}: {{ item.CompanyName }}
                  </div>
                  <span style="font-size: 10px; margin-right: 10px"
                    >{{ $t.tradeOrder.brand }}: {{ item.Brand }}</span
                  >
                  <span style="font-size: 10px; margin-right: 10px"
                    >{{ $t.tradeOrder.model }}: {{ item.Model }}</span
                  >
                  <span style="font-size: 10px"
                    >{{ $t.tradeOrder.specifications }}: {{ item.Specifications }}</span
                  >
                </template>
                <template #footer>
                  <van-button
                    size="small"
                    type="danger"
                    native-type="button"
                    @click="procurementProductDelete(index)"
                  >
                    <van-icon name="delete" size="1.2rem" />
                  </van-button>
                </template>
              </van-card>
            </div>
            <div v-else class="empty-text">{{ $t.meta.noData }}</div>

            <div class="total-info">
              <van-cell :title="$t.tradeOrder.total1" :value="totalQty" />
              <van-cell
                :title="$t.tradeOrder.total2"
                :value="'¥' + totalAmount.toFixed(2)"
              />
            </div>

            <div style="padding: 16px">
              <van-button round block type="info" native-type="submit">
                {{ $t.tradeOrder.button1 }}
              </van-button>
            </div>
          </div>
        </van-form>
      </van-collapse-item>

      <!-- 销售信息面板 -->
      <van-collapse-item :title="$t.tradeOrder.collapse2" name="sales">
        <van-form
          ref="form2"
          label-width="120px"
          :show-error="false"
          :scroll-to-error="false"
          @failed="onFailed"
          @submit="handleSubmit"
        >
          <van-cell-group>
            <van-field
              v-model="form2.selectedCustomer.text"
              :label="$t.tradeOrder.customerName"
              :name="$t.tradeOrder.customerName"
              readonly
              required
              :rules="formRule"
              :placeholder="$t.meta.input"
              type="textarea"
              autosize
              @click="onShowEmit('showTradeOrderCreateCustomer')"
            />
            <van-field
              v-model="form2.selectedBank.text"
              :label="$t.tradeOrder.accountNo"
              :name="$t.tradeOrder.accountNo"
              readonly
              required
              :rules="formRule"
              :placeholder="$t.meta.select"
              :disabled="!form2.selectedCustomer.value"
              @click="onBankShow"
            />
            <van-field
              v-model="form2.Contact"
              :label="$t.tradeOrder.contact"
              :placeholder="$t.meta.input"
            />
            <van-field
              v-model="form2.ContactPhone"
              :label="$t.tradeOrder.phoneNumber"
              :placeholder="$t.meta.input"
              type="tel"
            />
            <van-field
              v-model="form2.selectedCountry.text"
              :label="$t.tradeOrder.deliveryCountry"
              readonly
              :placeholder="$t.meta.select"
              @click="onShowEmit('showTradeOrderCreateCountry')"
            />
            <van-field
              v-model="form2.DeliveryDestination"
              :label="$t.tradeOrder.deliveryDestination"
              :placeholder="$t.meta.input"
            />
            <van-field
              v-model="form2.Address"
              :label="$t.tradeOrder.address"
              :placeholder="$t.meta.input"
              type="textarea"
              autosize
            />
            <van-field
              v-model="form2.selectedEntity.text"
              :label="$t.tradeOrder.entity"
              :name="$t.tradeOrder.entity"
              readonly
              required
              :rules="formRule"
              :placeholder="$t.meta.input"
              type="textarea"
              autosize
              @click="onShowEmit('showTradeOrderCreateEntity2')"
            />
            <van-field
              v-model="form2.selectedAccount.text"
              :label="$t.tradeOrder.bankAccount"
              :name="$t.tradeOrder.bankAccount"
              readonly
              required
              :rules="formRule"
              :placeholder="$t.meta.select"
              :disabled="!form2.selectedEntity.value"
              @click="onAccountShow"
            />
            <van-field
              v-model="form2.TCIdStr"
              :label="$t.tradeOrder.tradeTerms"
              :name="$t.tradeOrder.tradeTerms"
              readonly
              required
              :rules="formRule"
              :placeholder="$t.meta.select"
              @click="showTCPicker = true"
            />
            <van-field
              v-model="form2.ProcurementFeeRate"
              :label="$t.tradeOrder.procurementFeeRate"
              :name="$t.tradeOrder.procurementFeeRate"
              type="number"
              :placeholder="$t.meta.input"
              @change="calculateSaleProduct"
              required
              :rules="formRule"
            >
              <template #button>
                <span>%</span>
              </template>
            </van-field>
            <van-field
              v-model="form2.currency.text"
              :label="$t.tradeOrder.tradeCurrency"
              :name="$t.tradeOrder.tradeCurrency"
              readonly
              required
              :rules="formRule"
              :placeholder="$t.meta.select"
              @click="showCurrencyPicker = true"
            />
            <van-field
              v-model="form2.ExchangeRate"
              :label="$t.tradeOrder.exchangeRate"
              :name="$t.tradeOrder.exchangeRate"
              type="number"
              :placeholder="$t.meta.input"
              @change="calculateSaleProduct"
              required
              :rules="formRule"
            >
              <template #button v-if="form2.currency">
                <span>¥⇋{{ form2.currency.CurrencySymbol }}</span>
              </template>
            </van-field>
            <van-field
              v-model="form2.FOB_SCId.text"
              :label="$t.tradeOrder.fobCurrency"
              :name="$t.tradeOrder.fobCurrency"
              readonly
              required
              :rules="formRule"
              :placeholder="$t.meta.select"
              @click="showFobCurrencyPicker = true"
            />
            <van-field
              v-model="form2.FOB_LocalCost"
              :label="$t.tradeOrder.fobCost"
              :name="$t.tradeOrder.fobCost"
              type="number"
              :placeholder="$t.meta.input"
              required
              :rules="formRule"
            />
            <van-field
              v-model="form2.WorkOrderNumber"
              :label="$t.tradeOrder.jobNumber"
              :placeholder="$t.meta.input"
            />
            <van-field
              v-model="form2.PurchaseOrderCode"
              :label="$t.tradeOrder.orderNumber"
              :placeholder="$t.meta.input"
            />
          </van-cell-group>

          <van-cell-group>
            <van-cell class="exportCheckbox" :title="$t.tradeOrder.checkbox1">
              <template #right-icon>
                <van-checkbox v-model="form2.IsExportTaxRebate" />
              </template>
            </van-cell>
          </van-cell-group>

          <!-- 销售清单 -->
          <div class="product-list">
            <div class="list-title">{{ $t.tradeOrder.subTitle2 }}</div>
            <div v-if="salesProductList.length > 0">
              <van-card
                v-for="(item, index) in salesProductList"
                :key="index"
                :title="item.ProductName"
                :thumb="item.ProductImage ? imgUrlFilter(item.ProductImage) : cargoImg"
              >
                <template #tags>
                  <div style="font-size: 10px">
                    {{ $t.tradeOrder.customsDeclarationInfo }}:
                    {{ item.CustomsDeclarationInfo }}
                  </div>
                  <span style="font-size: 10px; margin-right: 10px"
                    >{{ $t.tradeOrder.brand }}: {{ item.Brand }}</span
                  >
                  <span style="font-size: 10px; margin-right: 10px"
                    >{{ $t.tradeOrder.model }}: {{ item.Model }}</span
                  >
                  <span style="font-size: 10px"
                    >{{ $t.tradeOrder.specifications }}: {{ item.Specifications }}</span
                  >
                </template>
                <template #price>
                  <van-field
                    v-model="item.SalesUnitPrice"
                    type="number"
                    :label="$t.tradeOrder.salesUnitPrice"
                    :name="$t.tradeOrder.salesUnitPrice"
                    :placeholder="item.PurchaseUnitPrice.toString()"
                    @change="calculateSaleProduct"
                    style="border: 2px solid #1989fa; margin: 5px; padding: 5px"
                    :rules="formRule"
                  >
                    <template #button v-if="form2.currency">
                      {{ form2.currency.CurrencySymbol }}
                    </template>
                  </van-field>
                </template>
                <template #footer>
                  <div class="card-footer">
                    <div class="subTotal">
                      <div>
                        {{ $t.tradeOrder.subtotal }} {{ form2.currency.CurrencySymbol
                        }}{{ item.SubTotal.toFixed(2) }}
                      </div>
                      <div>
                        {{ $t.tradeOrder.refundSubtotal }} ¥{{
                          item.TaxRefundSubtotal.toFixed(2)
                        }}
                      </div>
                    </div>
                    <div class="quantity">
                      {{ item.SalesQuantity }}{{ item.UnitName }}
                    </div>
                  </div>
                </template>
              </van-card>
            </div>
            <div v-else class="empty-text">{{ $t.meta.noData }}</div>
          </div>

          <!-- 汇总信息 -->
          <van-cell-group class="total-group">
            <van-cell
              :title="$t.tradeOrder.total3"
              :value="
                (form2.currency.CurrencySymbol ? form2.currency.CurrencySymbol : '') +
                totalSales.toFixed(2)
              "
            />
            <van-cell
              :title="$t.tradeOrder.total4"
              :value="'¥' + totalSalesCNY.toFixed(2)"
            />
            <van-cell
              :title="$t.tradeOrder.total5"
              :value="
                (form2.currency.CurrencySymbol ? form2.currency.CurrencySymbol : '') +
                totalHandlingFee.toFixed(2)
              "
            />
            <van-cell
              :title="$t.tradeOrder.total6"
              :value="'¥' + totalHandlingFeeCNY.toFixed(2)"
            />
            <van-cell
              :title="$t.tradeOrder.total7"
              :value="'¥' + totalReceiveAmount.toFixed(2)"
            />
            <van-cell
              :title="$t.tradeOrder.total8"
              :value="'¥' + totalReceiveProfit.toFixed(2)"
            />
            <van-cell
              :title="$t.tradeOrder.total9"
              :value="totalProfitRate.toFixed(2) + '%'"
            />
            <van-cell
              :title="$t.tradeOrder.total10"
              :value="'¥' + totalRefund.toFixed(2)"
            />
            <van-cell :title="$t.tradeOrder.button3">
              <template #right-icon>
                <van-checkbox
                  v-model="form2.IsTaxRefundByOrderReceivable"
                  @change="calculateSaleProduct"
                />
              </template>
            </van-cell>
          </van-cell-group>

          <div class="action-buttons">
            <van-button round block type="info" native-type="submit">{{
              $t.meta.submit
            }}</van-button>
            <van-button round block native-type="button" @click="dialogSaveDraftShow">{{
              $t.tradeOrder.saveDraft
            }}</van-button>
          </div>
        </van-form>
      </van-collapse-item>
    </van-collapse>

    <!-- 产品选择器 -->
    <option-list
      event="showTradeOrderCreateProduct"
      :options="productList"
      @onSelect="onProductConfirm"
    ></option-list>

    <!-- 国家选择器 -->
    <option-list
      event="showTradeOrderCreateCountry"
      :options="countryList"
      @onSelect="onCountryConfirm"
    ></option-list>

    <!-- 供应商选择器 -->
    <van-popup v-model="showCompanyPicker" position="bottom">
      <van-picker
        :title="$t.tradeOrder.supplier"
        show-toolbar
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        :columns="companyList"
        @confirm="onCompanyConfirm"
        @cancel="showCompanyPicker = false"
      />
    </van-popup>

    <!-- 报价选择器 -->
    <van-popup v-model="showQuotationPicker" position="bottom">
      <van-picker
        :title="$t.tradeOrder.quotation"
        show-toolbar
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        :columns="productQuotationList"
        @confirm="onQuotationConfirm"
        @cancel="showQuotationPicker = false"
      />
    </van-popup>

    <!-- 营业主体选择器 -->
    <entity-fetch-list
      event="showTradeOrderCreateEntity1"
      type="purchasingManagement"
      request="getAvailableBusinessEntityList"
      @onSelect="onEntityConfirm"
    ></entity-fetch-list>

    <entity-fetch-list
      event="showTradeOrderCreateEntity2"
      type="purchasingManagement"
      request="getAvailableBusinessEntityList"
      @onSelect="onEntity2Confirm"
    ></entity-fetch-list>

    <!-- 客户选择器 -->
    <fetch-list
      event="showTradeOrderCreateCustomer"
      type="customerManagement"
      request="getCustomerInfoSearchList"
      @onSelect="onCustomerConfirm"
    ></fetch-list>

    <!-- 银行选择器 -->
    <van-popup v-model="showBankPicker" position="bottom">
      <van-picker
        :title="$t.tradeOrder.accountNo"
        show-toolbar
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        :columns="bankInfoList"
        @confirm="onBankConfirm"
        @cancel="showBankPicker = false"
      />
    </van-popup>

    <!-- 账户选择器 -->
    <van-popup v-model="showAccountPicker" position="bottom">
      <van-picker
        :title="$t.tradeOrder.bankAccount"
        show-toolbar
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        :columns="accountInfoList"
        @confirm="onAccountConfirm"
        @cancel="showAccountPicker = false"
      />
    </van-popup>

    <!-- 贸易条款选择器 -->
    <van-popup v-model="showTCPicker" position="bottom">
      <van-picker
        :title="$t.tradeOrder.tradeTerms"
        show-toolbar
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        :columns="tcList"
        @confirm="onTCConfirm"
        @cancel="showTCPicker = false"
      />
    </van-popup>

    <!-- 货币选择器 -->
    <van-popup v-model="showCurrencyPicker" position="bottom">
      <van-picker
        :title="$t.meta.currency"
        show-toolbar
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        :columns="currencyList"
        @confirm="onCurrencyConfirm"
        @cancel="showCurrencyPicker = false"
      />
    </van-popup>

    <!-- FOB货币选择器 -->
    <van-popup v-model="showFobCurrencyPicker" position="bottom">
      <van-picker
        :title="$t.meta.currency"
        show-toolbar
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        :columns="currencyList"
        @confirm="onFobCurrencyConfirm"
        @cancel="showFobCurrencyPicker = false"
      />
    </van-popup>

    <!-- 草稿保存弹窗 -->
    <van-dialog
      v-model="dialogSaveDraftVisible"
      :title="$t.tradeOrder.saveDraft"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
      @confirm="saveDraftSubmit"
    >
      <slot name="default">
        <div class="tradeOrderCreate-alert">
          <van-field
            v-model="saveDraftForm.DraftName"
            type="textarea"
            :placeholder="$t.tradeOrder.draftName"
          />
        </div>
      </slot>
    </van-dialog>

    <!-- 草稿列表弹窗 -->
    <option-list
      event="showTradeOrderCreateDraft"
      :options="draftData"
      @onSelect="onDraftConfirm"
    ></option-list>

    <van-action-sheet
      v-model="moreSheetShow"
      :actions="moreSheetActions"
      @select="moreSheetSelect"
    />

    <div class="tool-bar">
      <van-button
        type="info"
        block
        @click="procurementProductSyn"
        class="submit-button"
        >{{ $t.tradeOrder.button2 }}</van-button
      >
      <van-button class="more-button" @click="handleMoreSheetShow">{{
        $t.meta.more
      }}</van-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Cell,
  CellGroup,
  Icon,
  Image,
  Checkbox,
  CheckboxGroup,
  Popup,
  Collapse,
  CollapseItem,
  Picker,
  Search,
  ActionSheet,
  Card,
  Tag,
} from "vant";
import OptionList from "@components/optionList/OptionList.vue";
import FetchList from "@components/fetchList/FetchList.vue";
import EntityFetchList from "@components/entityFetchList/EntityFetchList.vue";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Cell)
  .use(CellGroup)
  .use(Icon)
  .use(Image)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(Collapse)
  .use(CollapseItem)
  .use(Picker)
  .use(Search)
  .use(ActionSheet)
  .use(Card)
  .use(Tag);

export default {
  name: "tradeOrderCreate",
  components: {
    OptionList,
    FetchList,
    EntityFetchList,
  },
  data() {
    return {
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      cargoImg: require("@/assets/img/warehouseManagement/cargo.png"),
      TOId: "",
      activeCollapse: [],
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],

      // 选择器控制
      showCompanyPicker: false,
      showQuotationPicker: false,
      showBankPicker: false,
      showAccountPicker: false,
      showTCPicker: false,
      showCurrencyPicker: false,
      showFobCurrencyPicker: false,

      // 草稿
      TODId: "",
      DraftName: "",
      dialogSaveDraftVisible: false,
      saveDraftForm: { DraftName: "" },
      draftData: [],

      // 搜索表单
      searchForm: {
        ProductName: "",
        Brand: "",
        Model: "",
        Specifications: "",
      },

      // 数据列表
      productList: [],
      companyList: [],
      productQuotationList: [],
      currencyList: [],
      tcList: [],
      countryList: [],
      entityInfoList: [],
      bankInfoList: [],
      accountInfoList: [],

      // 采购表单
      form: {
        selectedProduct: { value: null, text: "" },
        selectedCompany: { value: null, text: "" },
        selectedEntity: { value: null, text: "" },
        selectedQuotation: {
          PQId: null,
          PurchaseQuotationNumber: "",
          PreTaxPurchasePrice: null,
          InvoicingTaxRate: null,
          InvoiceType: null,
          AfterTaxPurchasePrice: null,
          InvoiceIncludingTaxRate: null,
          ProductTaxAmount: null,
          MinimumOrderQuantity: null,
          ProcurementConsiderations: "",
          CreateTime: "",
        },
        selectedQty: null,
      },

      // 销售表单
      form2: {
        selectedCustomer: { text: "", value: null },
        selectedBank: { text: "", value: null },
        selectedEntity: { text: "", value: null },
        selectedAccount: { text: "", value: null },
        currency: { text: "", value: null, CurrencySymbol: "" },
        Contact: "",
        ContactPhone: "",
        Address: "",
        selectedCountry: { text: "", value: null },
        DeliveryDestination: "",
        TCIdStr: "",
        TCId: null,
        ProcurementFeeRate: null,
        ExchangeRate: null,
        FOB_SCId: { text: "", value: null },
        FOB_LocalCost: null,
        WorkOrderNumber: "",
        PurchaseOrderCode: "",
        IsExportTaxRebate: false,
        IsTaxRefundByOrderReceivable: false,
      },

      // 采购产品清单
      procurementProductList: [],
      // 销售产品清单
      salesProductList: [],
      // 统计数据
      totalQty: 0,
      totalAmount: 0,
      totalSales: 0,
      totalSalesCNY: 0,
      totalRefund: 0,
      totalHandlingFee: 0,
      totalHandlingFeeCNY: 0,
      totalReceiveAmount: 0,
      totalReceiveProfit: 0,
      totalProfitRate: 0,
      //更多
      moreSheetShow: false,
      moreSheetActions: [],
    };
  },
  created() {
    let route = this.$route.query;
    if (route.TOId) {
      this.TOId = route.TOId;
      this.activeCollapse = ["sales"];
      this.getOptions().then(() => {
        this.getTradeOrderByTOId();
      });
    } else {
      this.activeCollapse = ["purchase", "sales"];
      this.getOptions();
    }
  },

  methods: {
    moreSheetSelect(e) {
      if (e.className == "1") {
        this.dialogDraftListShow();
      }
      this.moreSheetShow = false;
    },
    handleMoreSheetShow() {
      var actions = [];
      actions = [
        {
          name: this.$t.tradeOrder.viewDraft,
          className: "1",
        },
      ];

      this.moreSheetActions = actions;
      this.moreSheetShow = true;
    },
    // 获取订单详情
    getTradeOrderByTOId() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        var param = { TOId: this.TOId };
        this.$api.purchasingManagement
          .getTradeOrderByTOId(param)
          .then((res) => {
            this.applyData(res.data);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },

    applyData(data) {
      // 采购产品清单
      if (data.ProcurementProductList.length > 0) {
        this.procurementProductList = data.ProcurementProductList.map((procurement) => ({
          PId: procurement.PId,
          ProductName: procurement.ProductName,
          ProductImage: procurement.ProductImage,
          Brand: procurement.Brand,
          Model: procurement.Model,
          Specifications: procurement.Specifications,
          UnitName: procurement.UnitName,
          CustomsDeclarationInfo: procurement.CustomsDeclarationInfo,
          CustomerId: procurement.CustomerId,
          CustomerName: procurement.CustomerName,
          PQId: procurement.PQId,
          PurchaseUnitPrice: procurement.PurchaseUnitPrice,
          ProductTaxAmount:
            data.SalesProductList.find((p) => p.PId == procurement.PId)
              .ProductTaxAmount || 0,
          BEId: procurement.BEId,
          CompanyName: procurement.CompanyName,
          PurchaseQuantity: procurement.PurchaseQuantity,
          Subtotal: procurement.Subtotal,
        }));
      }
      this.calculateTotalQty();
      this.calculateTotalAmount();

      // 销售信息
      this.form2.selectedCustomer = {
        text: data.CompanyName,
        value: data.CustomerId,
        CustomerNumber: data.CustomerNumber,
      };
      if (data.CustomerId) {
        this.getBankAccountByCustomerNumber();
      }
      this.form2.selectedBank = {
        text: data.CustomerAccountNo,
        value: data.BankId,
      };
      this.form2.selectedEntity = {
        text: data.SalesCompanyName,
        value: data.BEId,
      };
      if (data.BEId) {
        this.getBusinessEntityCollectionAccountListByBEId();
      }
      this.form2.selectedAccount = {
        text: data.SalesAccountNumber,
        value: data.AccountId,
        AccountNickName: data.SalesAccountNickName,
        AccountName: data.SalesAccountName,
        BankName: data.SalesBankName,
      };
      this.form2.currency = {
        text: data.CurrencySn,
        value: data.SCId,
        CurrencySymbol: data.CurrencySymbol,
      };
      this.form2.Contact = data.Contact;
      this.form2.ContactPhone = data.ContactPhone;
      this.form2.Address = data.Address;
      var country = this.countryList.find(
        (country) => country.value == data.DeliveryCountryId
      );
      this.form2.selectedCountry = {
        text: country ? country.text : "",
        value: data.DeliveryCountryId,
      };
      this.form2.DeliveryDestination = data.DeliveryDestination;
      this.form2.TCIdStr = data.TCName;
      this.form2.TCId = data.TCId;
      this.form2.ProcurementFeeRate = data.ProcurementFeeRate;
      this.form2.ExchangeRate = data.ExchangeRate;
      this.form2.FOB_SCId = {
        text: data.FOB_CurrencySn,
        value: data.FOB_SCId,
      };
      this.form2.FOB_LocalCost = data.FOB_LocalCost;
      this.form2.WorkOrderNumber = data.WorkOrderNumber;
      this.form2.PurchaseOrderCode = data.PurchaseOrderCode;
      this.form2.IsExportTaxRebate = data.IsExportTaxRebate == 1;
      this.form2.IsTaxRefundByOrderReceivable = data.IsTaxRefundByOrderReceivable == 1;

      // 销售产品清单
      if (data.SalesProductList.length > 0) {
        this.salesProductList = data.SalesProductList.map((salesProduct) => ({
          PId: salesProduct.PId,
          ProductName: salesProduct.ProductName,
          ProductImage: salesProduct.ProductImage,
          Brand: salesProduct.Brand,
          Model: salesProduct.Model,
          Specifications: salesProduct.Specifications,
          UnitName: salesProduct.UnitName,
          CustomsDeclarationInfo: salesProduct.CustomsDeclarationInfo,
          SalesQuantity: salesProduct.SalesQuantity,
          PQId: salesProduct.PQId,
          PurchaseUnitPrice: salesProduct.SalesUnitPrice,
          ProductTaxAmount: salesProduct.ProductTaxAmount,
          SalesUnitPrice: salesProduct.SalesUnitPrice,
          SubTotal: salesProduct.Subtotal,
          TaxRefundSubtotal: salesProduct.TaxRefundSubtotal,
        }));
      }
      this.calculateSaleProduct();
    },

    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([
          this.getCurrencyList(),
          this.getTradeClauseList(),
          this.getCountryList(),
        ])
          .then((success) => {
            if (success) {
              resolve(true);
            }
            this.$commonMethod.hideLoading();
          })
          .catch(() => {
            this.$commonMethod.hideLoading();
          });
      });
    },

    getCurrencyList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getSystemAvailableCurrencyList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CurrencySn,
                value: item,
              };
              result.push(data);
            });
            this.currencyList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },

    getTradeClauseList() {
      return new Promise((resolve) => {
        this.$api.purchasingManagement
          .getTradeClauseList({})
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.TCName,
                value: item.TCId,
              };
              result.push(data);
            });
            this.tcList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },

    getCountryList() {
      return new Promise((resolve) => {
        this.$api.customerManagement
          .getCountryList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CountryName + "," + item.CountryName_en,
                value: item.CountryId,
              };
              result.push(data);
            });
            this.countryList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },

    procurementProductDelete(index) {
      this.procurementProductList.splice(index, 1);
      this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
        titleMsg: this.$t.tradeOrder.deleteSuccess,
        type: "success",
      });
      this.calculateTotalQty();
      this.calculateTotalAmount();
    },

    procurementProductSyn() {
      if (!this.form2.ExchangeRate) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.meta.input + " " + this.$t.tradeOrder.exchangeRate,
          type: "error",
        });
        return;
      }
      if (this.procurementProductList.length > 0) {
        this.salesProductList = this.procurementProductList.map((item) => {
          let exist = this.salesProductList.find((p) => p.PQId == item.PQId);
          return {
            PId: item.PId,
            ProductName: item.ProductName,
            ProductImage: item.ProductImage,
            Brand: item.Brand,
            Model: item.Model,
            Specifications: item.Specifications,
            UnitName: item.UnitName,
            CustomsDeclarationInfo: item.CustomsDeclarationInfo,
            SalesQuantity: item.PurchaseQuantity,
            PQId: item.PQId,
            PurchaseUnitPrice: this.form2.ExchangeRate
              ? (item.PurchaseUnitPrice / this.form2.ExchangeRate).toFixed(4)
              : item.PurchaseUnitPrice,
            ProductTaxAmount: item.ProductTaxAmount,
            SalesUnitPrice: exist?.SalesUnitPrice || null,
            SubTotal: 0,
            TaxRefundSubtotal: 0,
          };
        });
        this.calculateSaleProduct();
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.meta.operateSuccess,
          type: "success",
        });
      } else {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.tradeOrder.synError,
          type: "error",
        });
      }
    },

    procurementProductSubmit() {
      if (!this.form.selectedProduct.value) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.meta.select + " " + this.$t.tradeOrder.productName,
          type: "error",
        });
        return;
      }
      if (!this.form.selectedCompany.value) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.meta.select + " " + this.$t.tradeOrder.supplier,
          type: "error",
        });
        return;
      }
      if (!this.form.selectedQuotation.value) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.meta.select + " " + this.$t.tradeOrder.quotation,
          type: "error",
        });
        return;
      }
      if (!this.form.selectedEntity.value) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.meta.input + " " + this.$t.tradeOrder.entity,
          type: "error",
        });
        return;
      }
      if (!this.form.selectedQty) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.meta.input + " " + this.$t.tradeOrder.quantity,
          type: "error",
        });
        return;
      }
      if (
        this.form.selectedQty < this.form.selectedQuotation.value.MinimumOrderQuantity
      ) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.tradeOrder.quantityError,
          type: "error",
        });
        return;
      }

      var data = {
        PId: this.form.selectedProduct.value.PId,
        ProductName: this.form.selectedProduct.value.ProductName,
        ProductImage: this.form.selectedProduct.value.ProductImages,
        Brand: this.form.selectedProduct.value.Brand,
        Model: this.form.selectedProduct.value.Model,
        Specifications: this.form.selectedProduct.value.Specifications,
        UnitName: this.form.selectedProduct.value.UnitName,
        CustomsDeclarationInfo: this.form.selectedProduct.value.CustomsDeclarationInfo,
        CustomerId: this.form.selectedCompany.value.CustomerId,
        CustomerName: this.form.selectedCompany.value.CustomerName,
        PQId: this.form.selectedQuotation.value.PQId,
        PurchaseUnitPrice: this.form.selectedQuotation.value.AfterTaxPurchasePrice,
        ProductTaxAmount: this.form.selectedQuotation.value.ProductTaxAmount,
        BEId: this.form.selectedEntity.value.BEId,
        CompanyName: this.form.selectedEntity.text,
        PurchaseQuantity: this.form.selectedQty,
        Subtotal:
          this.form.selectedQuotation.value.AfterTaxPurchasePrice * this.form.selectedQty,
      };

      var exist = this.procurementProductList.find(
        (p) =>
          p.PId == this.form.selectedProduct.value.PId &&
          p.CustomerId == this.form.selectedCompany.value.CustomerId
      );
      if (exist) {
        var index = this.procurementProductList.findIndex(
          (p) =>
            p.PId == this.form.selectedProduct.value.PId &&
            p.CustomerId == this.form.selectedCompany.value.CustomerId
        );
        this.procurementProductList.splice(index, 1);
        this.procurementProductList.push(data);
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.tradeOrder.updateSuccess,
          type: "success",
        });
      } else {
        this.procurementProductList.push(data);
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.tradeOrder.addSuccess,
          type: "success",
        });
      }
      this.calculateTotalQty();
      this.calculateTotalAmount();
    },

    calculateTotalQty() {
      this.totalQty = this.procurementProductList.reduce(
        (sum, p) => sum + (parseFloat(p.PurchaseQuantity) || 0),
        0
      );
    },

    calculateTotalAmount() {
      this.totalAmount = this.procurementProductList.reduce(
        (sum, p) => sum + (parseFloat(p.Subtotal) || 0),
        0
      );
    },

    calculateSaleProduct() {
      if (!this.salesProductList.length) return;

      let totalSales = 0;
      let totalRefund = 0;

      this.salesProductList.forEach((item) => {
        if (item.SalesUnitPrice) {
          item.SubTotal = item.SalesUnitPrice * item.SalesQuantity;
          item.TaxRefundSubtotal = item.ProductTaxAmount * item.SalesQuantity;
        } else {
          item.SubTotal = 0;
          item.TaxRefundSubtotal = 0;
        }
        totalSales += item.SubTotal;
        totalRefund += item.TaxRefundSubtotal;
      });

      this.totalSales = totalSales;
      this.totalRefund = totalRefund;

      if (this.totalSales && this.form2.ExchangeRate) {
        this.totalSalesCNY = this.totalSales * this.form2.ExchangeRate;
        this.totalHandlingFee = parseFloat(
          (this.totalSales * (this.form2.ProcurementFeeRate / 100)).toFixed(2)
        );
        this.totalHandlingFeeCNY = parseFloat(
          (this.totalSalesCNY * (this.form2.ProcurementFeeRate / 100)).toFixed(2)
        );

        if (this.form2.IsTaxRefundByOrderReceivable) {
          this.totalReceiveAmount =
            this.totalSalesCNY + this.totalRefund + this.totalHandlingFeeCNY;
        } else {
          this.totalReceiveAmount = this.totalSalesCNY + this.totalHandlingFeeCNY;
        }

        this.totalReceiveProfit = this.totalReceiveAmount - this.totalAmount;
        this.totalProfitRate = (this.totalReceiveProfit / this.totalReceiveAmount) * 100;
      }
    },

    onSearch() {
      this.getProcurementProductListByCondition().then(() => {
        if (this.form.selectedProduct.value) {
          this.initFormData();
        }
        this.onShowEmit("showTradeOrderCreateProduct");
      });
    },

    getProcurementProductListByCondition() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.purchasingManagement
          .getProcurementProductListByCondition(this.searchForm)
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.ProductName + "-" + item.Specifications,
                image: item.ProductImages,
                value: item,
              };
              result.push(data);
            });
            this.productList = result;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },

    productChange(product) {
      if (product.value) {
        this.form.selectedProduct = product;
        this.getProcurementProductQuotationListByPId();
      }
    },

    initFormData() {
      this.form.selectedCompany.text = "";
      this.form.selectedCompany.value = { CustomerId: null, CustomerName: "" };
      this.form.selectedQuotation.text = "";
      this.form.selectedQuotation.value = {
        PQId: null,
        PurchaseQuotationNumber: "",
        PreTaxPurchasePrice: null,
        InvoicingTaxRate: null,
        InvoiceType: null,
        AfterTaxPurchasePrice: null,
        InvoiceIncludingTaxRate: null,
        ProductTaxAmount: null,
        MinimumOrderQuantity: null,
        ProcurementConsiderations: "",
        CreateTime: "",
      };
      this.productQuotationList = [];
    },

    getProcurementProductQuotationListByPId() {
      this.$commonMethod.showLoading();
      var param = { PId: this.form.selectedProduct.value.PId };
      this.$api.purchasingManagement
        .getProcurementProductQuotationListByPId(param)
        .then((res) => {
          var result = [];
          res.data.forEach((item) => {
            let data = {
              text: item.CustomerName + "(" + item.CustomerNumber + ")",
              value: item,
              ProductQuotationList: item.ProductQuotationList,
            };
            result.push(data);
          });
          this.companyList = result;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },

    companyChange(company) {
      this.form.selectedCompany = company;
      for (var c of this.companyList) {
        if (c.value.CustomerId == company.value.CustomerId) {
          for (var quotation of c.value.ProductQuotationList) {
            this.productQuotationList.push({
              text: quotation.PurchaseQuotationNumber + quotation.AfterTaxPurchasePrice,
              value: quotation,
            });
          }
          break;
        }
      }
    },

    // 选择器回调

    onProductConfirm(value) {
      this.productChange(value);
    },

    onCompanyConfirm(value) {
      this.companyChange(value);
      this.showCompanyPicker = false;
    },

    onQuotationConfirm(item) {
      this.form.selectedQuotation.text = item.text;
      this.form.selectedQuotation.value = item.value;
      this.showQuotationPicker = false;
    },

    onEntityConfirm(item) {
      this.form.selectedEntity.text = item.text;
      this.form.selectedEntity.value = item.value;
      this.$forceUpdate();
    },

    onEntity2Confirm(item) {
      this.form2.selectedEntity.text = item.text;
      this.form2.selectedEntity.value = item.value;
      this.getBusinessEntityCollectionAccountListByBEId();
      this.$forceUpdate();
    },

    onCustomerConfirm(value) {
      this.form2.selectedCustomer = value;
      this.getBankAccountByCustomerNumber();
    },

    onCountryConfirm(item) {
      this.form2.selectedCountry.text = item.text;
      this.form2.selectedCountry.value = item.value;
      this.$forceUpdate();
    },

    onBankConfirm(item) {
      this.form2.selectedBank.text = item.text;
      this.form2.selectedBank.value = item.value;
      this.showBankPicker = false;
    },

    onBankShow() {
      if (this.bankInfoList.length > 0) {
        this.showBankPicker = true;
      } else {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.tradeOrder.pickerError1,
          type: "error",
        });
      }
    },

    onAccountConfirm(item) {
      this.form2.selectedAccount.text = item.text;
      this.form2.selectedAccount.value = item.value;
      this.showAccountPicker = false;
    },

    onAccountShow() {
      if (this.accountInfoList.length > 0) {
        this.showAccountPicker = true;
      } else {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.tradeOrder.pickerError2,
          type: "error",
        });
      }
    },

    onTCConfirm(item) {
      this.form2.TCIdStr = item.text;
      this.form2.TCId = item.value;
      this.showTCPicker = false;
    },

    onCurrencyConfirm(item) {
      this.form2.currency.text = item.text;
      this.form2.currency.value = item.value.SCId;
      this.form2.currency.CurrencySymbol = item.value.CurrencySymbol;
      this.calculateSaleProduct();
      this.showCurrencyPicker = false;
    },

    onFobCurrencyConfirm(item) {
      this.form2.FOB_SCId.text = item.text;
      this.form2.FOB_SCId.value = item.value.SCId;
      this.showFobCurrencyPicker = false;
    },

    onDraftConfirm(item) {
      this.procurementProductList = [];
      this.salesProductList = [];
      this.applyData(item.value);
      this.TODId = item.TODId;
      this.DraftName = item.text;
      this.activeCollapse = ["sales"];
      this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
        titleMsg: this.$t.meta.operateSuccess,
        type: "success",
      });
    },

    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },

    pickerShow(pickerName) {
      if (pickerName == "showCompanyPicker" && this.companyList.length == 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.tradeOrder.pickerError3,
          type: "error",
        });
        return;
      }
      if (pickerName == "showQuotationPicker" && this.productQuotationList.length == 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: this.$t.tradeOrder.pickerError4,
          type: "error",
        });
        return;
      }
      this[pickerName] = true;
    },

    getBusinessEntityCollectionAccountListByBEId() {
      this.$commonMethod.showLoading();
      var param = { BEId: this.form2.selectedEntity.value };
      this.$api.purchasingManagement
        .getBusinessEntityCollectionAccountListByBEId(param)
        .then((res) => {
          var result = [];
          res.data.forEach((item) => {
            let data = {
              text: item.AccountNumber,
              value: item.AccountId,
            };
            result.push(data);
          });
          this.accountInfoList = result;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },

    getBankAccountByCustomerNumber() {
      this.$commonMethod.showLoading();
      var param = { CustomerNumber: this.form2.selectedCustomer.CustomerNumber };
      this.$api.purchasingManagement
        .getBankAccountByCustomerNumber(param)
        .then((res) => {
          var result = [];
          res.data.forEach((item) => {
            let data = {
              text: item.AccountNo,
              value: item.BankId,
            };
            result.push(data);
          });
          this.bankInfoList = result;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },

    // 草稿相关
    dialogDraftListShow() {
      this.getTradeOrderDraftListByUserId().then((success) => {
        if (success) {
          this.onShowEmit("showTradeOrderCreateDraft");
        }
      });
    },

    deleteTradeOrderDraft() {
      let param = { TODId: this.TODId };
      this.$api.purchasingManagement.deleteTradeOrderDraft(param).then((res) => {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: res.message,
          type: "success",
        });
        this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
      });
    },

    getTradeOrderDraftListByUserId() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.purchasingManagement
          .getTradeOrderDraftListByUserId({})
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                TODId: item.TODId,
                text: item.DraftName,
                rightText: item.CreateTime,
                value: item.TradeOrder,
              };
              result.push(data);
            });
            this.draftData = result;
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },

    dialogSaveDraftShow() {
      this.dialogSaveDraftVisible = true;
    },

    saveDraftSubmit() {
      if (!this.saveDraftForm.DraftName) {
        return;
      }

      var param = {
        DraftName: this.saveDraftForm.DraftName,
        TradeOrder: this.getParams(),
      };
      this.$api.purchasingManagement.saveTradeOrderDraft(param).then((res) => {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
          titleMsg: res.message,
          type: "success",
        });
        this.dialogSaveDraftVisible = false;
      });
    },

    handleSubmit() {
      this.$commonMethod.showLoading();
      var param = this.getParams();
      var request = this.TOId
        ? this.$api.purchasingManagement.editTradeOrder({ ...param, TOId: this.TOId })
        : this.$api.purchasingManagement.addTradeOrder(param);

      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getParams() {
      return {
        CustomerId: this.form2.selectedCustomer.value,
        BankId: this.form2.selectedBank.value,
        BEId: this.form2.selectedEntity.value,
        AccountId: this.form2.selectedAccount.value,
        Contact: this.form2.Contact,
        ContactPhone: this.form2.ContactPhone,
        Address: this.form2.Address,
        DeliveryDestination: this.form2.DeliveryDestination,
        ProcurementFeeRate: this.form2.ProcurementFeeRate,
        SCId: this.form2.currency.value,
        ExchangeRate: this.form2.ExchangeRate,
        FOB_SCId: this.form2.FOB_SCId.value,
        FOB_LocalCost: this.form2.FOB_LocalCost,
        WorkOrderNumber: this.form2.WorkOrderNumber,
        PurchaseOrderCode: this.form2.PurchaseOrderCode,
        DeliveryCountryId: this.form2.selectedCountry.value,
        TCId: this.form2.TCId,
        IsExportTaxRebate: this.form2.IsExportTaxRebate ? 1 : 0,
        IsTaxRefundByOrderReceivable: this.form2.IsTaxRefundByOrderReceivable ? 1 : 0,
        ProcurementProductList: this.procurementProductList.map((item) => ({
          BEId: item.BEId,
          PQId: item.PQId,
          PurchaseQuantity: item.PurchaseQuantity,
        })),
        SalesProductList: this.salesProductList.map((item) => ({
          PQId: item.PQId,
          SalesUnitPrice: item.SalesUnitPrice,
        })),
      };
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    onFailed(errorInfo) {
      if (errorInfo && errorInfo.errors.length > 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: errorInfo.errors[0].name + " " + errorInfo.errors[0].message,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tradeOrderCreate {
  min-height: 100vh;
  padding-bottom: 20px;
  .van-search {
    background: transparent !important;
    .van-cell {
      border: none !important;
    }
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .van-cell-group {
    background: transparent !important;
  }
  ::v-deep .van-collapse-item__content {
    padding: 0px;
    background: transparent;
  }
  ::v-deep .van-collapse::after {
    border: none !important;
  }
  ::v-deep .van-collapse-item__title--expanded::after {
    display: none !important;
  }
  ::v-deep .van-button__text {
    font-size: 14px !important;
  }
  ::v-deep .exportCheckbox {
    .van-cell__title {
      color: #646566 !important;
    }
  }
  .header {
    z-index: 100;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background-color: #fff;
    border-bottom: 1px solid #ebedf0;
    .header-left {
      width: 33.33%;
      text-align: left;
      font-size: 14px;
      color: #1989fa;
    }
    .header-center {
      width: 33.33%;
      text-align: center;
      font-size: 14px;
      color: #666666;
    }
    .header-right {
      width: 33.33%;
      text-align: right;
      font-size: 14px;
      color: #ff5852;
    }
  }

  .collapse-container {
    ::v-deep .van-collapse-item__title {
      font-weight: 500;
      font-size: 16px;
      padding: 10px 15px;
      color: #fff;
      background: #1e90ff !important;
    }
    ::v-deep .van-cell__right-icon {
      font-weight: 500;
      font-size: 16px;
      color: #fff !important;
    }
    ::v-deep .van-hairline--top-bottom::after {
      display: none;
    }
  }

  .search-section {
    padding: 12px;
    background: transparent !important;
    border-radius: 8px;
    border-bottom: 1px solid #ebedf0;
    .search-tags {
      display: flex;
      gap: 8px;
      .van-cell::after {
        border: none !important;
      }
      .tag-input {
        flex: 1;
        ::v-deep .van-field__control {
          font-size: 12px;
        }
      }
    }
  }

  .product-preview {
    display: flex;
    justify-content: center;
    padding: 12px;

    .van-image {
      border-radius: 8px;
      overflow: hidden;
    }
  }

  .product-list {
    .list-title {
      font-size: 14px;
      color: #323233;
      padding: 12px 16px;
      text-align: center;
      border-bottom: 1px solid #ebedf0;
    }

    .van-card {
      background: transparent !important;
      .card-footer {
        font-size: 12px;
        color: #969799;
        margin-top: 10px;
      }
    }

    .total-info {
      margin-top: 1px;
      border-top: 1px solid #ebedf0;
    }

    .empty-text {
      text-align: center;
      padding: 20px;
      font-size: 12px;
      color: #969799;
    }
  }

  .total-group {
    margin-top: 10px;
    border-top: 1px solid #ebedf0;
    .refund-cell {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 12px;
    }
  }

  .action-buttons {
    padding: 16px;
    gap: 12px;
    display: flex;
    flex-direction: column;
  }
}

::v-deep {
  .van-field__button {
    font-size: 12px;
    color: #999;
  }
  .subTotal {
    display: inline-block;
    width: 50%;
    text-align: left;
    vertical-align: middle;
  }
  .quantity {
    display: inline-block;
    width: 50%;
    text-align: right;
    font-size: 14px;
    vertical-align: middle;
  }
}

.tradeOrderCreate-alert {
  overflow: scroll;
  height: auto;
  margin-top: 30px;
  margin-bottom: 30px;
  border-top: 1px solid #ebedf0;
  position: relative;
}

.tool-bar {
  box-sizing: border-box;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: white;
  z-index: 100;
  justify-content: space-between;
  padding-bottom: env(safe-area-inset-bottom);
  .submit-button {
    width: 70%;
    border: none;
    border-radius: 0px;
    display: inline-block;
  }
  .more-button {
    background: #5029c3;
    color: #fff;
    border: none;
    border-radius: 0px;
    display: inline-block;
    width: 30%;
  }
}
</style>
